import { render, staticRenderFns } from "./TreatyRIList.vue?vue&type=template&id=1899bf32&"
import script from "./TreatyRIList.vue?vue&type=script&lang=js&"
export * from "./TreatyRIList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports